import { render, staticRenderFns } from "./EditProducerGeneralSetting.vue?vue&type=template&id=77ff19d3&scoped=true&"
import script from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditProducerGeneralSetting.vue?vue&type=style&index=0&id=77ff19d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff19d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDivider,VRadio,VRadioGroup,VTextField})
